import { render, staticRenderFns } from "./ChatItem.vue?vue&type=template&id=077bd3bb&scoped=true"
import script from "./ChatItem.vue?vue&type=script&lang=js"
export * from "./ChatItem.vue?vue&type=script&lang=js"
import style0 from "./ChatItem.vue?vue&type=style&index=0&id=077bd3bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077bd3bb",
  null
  
)

export default component.exports